import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { RetailsTestID } from '../test-ids';
import { CitySearch } from './CitySearch';
import { GoBackButton } from './GoBackButton';
import { RetailsMap } from './Map';
import { ItemsContainer, NotFoundMessage, RetailsWrapper } from './Retails.styles';
import { RetailsContextProvider, useRetailsContext } from './RetailsContext';
import { RetailsSkeleton } from './RetailsSkeleton';
import { SalonInfo } from './SalonInfo';
import { SalonList } from './SalonList';
import { ToggleMapButton } from './ToggleMapButton';
import { VariantSelector } from './VariantSelector';
import { WeekendFilter } from './WeekendFilter';

type Props = {
    baseProductCode?: string;
};

export const RetailsContent: FC = () => {
    const { t } = useTranslations();
    const { baseProductCode, data } = useRetailsContext();

    if (!data) {
        return <RetailsSkeleton />;
    }

    if (baseProductCode && (!data.variantMatrix.length || !data.retails.length)) {
        return <NotFoundMessage>{t['retails_map.not_found']}</NotFoundMessage>;
    }

    return (
        <RetailsWrapper data-test={RetailsTestID.WRAPPER}>
            <ItemsContainer $gridArea="map">
                <RetailsMap />
            </ItemsContainer>
            <ItemsContainer $gridArea="above">
                <CitySearch />
                <WeekendFilter />
                <VariantSelector />
                <ToggleMapButton />
                <GoBackButton />
            </ItemsContainer>
            <ItemsContainer $gridArea="below">
                <SalonList />
                <SalonInfo />
            </ItemsContainer>
        </RetailsWrapper>
    );
};

export const Retails: FC<Props> = ({ baseProductCode }) => {
    return (
        <RetailsContextProvider baseProductCode={baseProductCode}>
            <RetailsContent />
        </RetailsContextProvider>
    );
};
